export default __webpack_public_path__ + "static/media/NO_MultiPerson.48c7af6c.jpg";